import { content } from '../../content';

export const render = (): void => {
    let footerCopyrightEl = document.querySelector(`#${content.FOOTER_COPYRIGHT.id}`);
    if (footerCopyrightEl) {
        const currentYear = new Date().getFullYear();
        footerCopyrightEl.textContent = currentYear.toString();
    }
};
